export default __webpack_public_path__ + "static/videoN3-733d6ca1aa54d462bb6d4e8eb7e0328e.webp";